import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { Flow } from "../../../../shared/components/Flow";
import { PATH_SETTINGS_ACCOUNT_PERSONAL } from "../../../Settings/paths";
import { PATH_ONBOARDING_US_PERSON_INFO } from "../..";
import { FlowUsPersonInfoContext, getUsPersonInfoSteps } from "./getSteps";

export const RouteUsPersonInfo: React.FC = () => {
  const history = useHistory();

  const goBack = useCallback(() => {
    history.push(PATH_SETTINGS_ACCOUNT_PERSONAL);
  }, [history]);

  return (
    <Flow
      basePath={PATH_ONBOARDING_US_PERSON_INFO}
      steps={(context: FlowUsPersonInfoContext) =>
        getUsPersonInfoSteps(context)
      }
      onBack={(context: FlowUsPersonInfoContext) => {
        goBack();
      }}
      onNext={goBack}
    />
  );
};
